import { type ShipmentPaymentMethod } from '~shared/types';

// Networking for shipment payment methods now lives in React Query
// (`useGetShipmentPaymentMethods` in queries/query-keys/shipmentPaymentMethods.ts).
// This action only mirrors the fetched data into the Redux slice so existing
// Reselect selectors (e.g. checkout's getOrder) keep working — the transitional
// bridge step toward strategy A. See the redux-thunk-to-react-query-migration skill.
export const SET_SHIPMENT_PAYMENT_METHODS = 'SET_SHIPMENT_PAYMENT_METHODS';

export type SetShipmentPaymentMethods = {
  type: typeof SET_SHIPMENT_PAYMENT_METHODS;
  payload: ShipmentPaymentMethod[];
};

export function setShipmentPaymentMethods(shipmentPaymentMethods: ShipmentPaymentMethod[]): SetShipmentPaymentMethods {
  return {
    type: SET_SHIPMENT_PAYMENT_METHODS,
    payload: shipmentPaymentMethods,
  };
}
